import { Text, TimeLimit } from '@opositandopn/ui';
import classnames from 'classnames';

import { BaseComponentProps } from '../../../../types/base-component.types';

import styles from './AssessmentSummary.module.scss';

type ContainerProps = BaseComponentProps & {
  /**
   * The quieter line over the name, saying which simulacro this is: "Simulacro de
   * teoría semanal".
   */
  heading?: string;
  name: string;
  /** In seconds. An assessment with no limit shows no clock. */
  timeLimit?: number;
  questionCount: number;
};

/**
 * What a simulacro asks of you and what it is called, as the home cards announce it:
 * how long, above; its name; how many questions, below. Shared so the cards on the
 * home screen read as one family rather than three arrangements of the same four
 * facts.
 */
function AssessmentSummary({
  className,
  heading,
  name,
  timeLimit,
  questionCount,
  testId = 'ui-assessment-summary',
}: ContainerProps) {
  return (
    <div
      className={classnames(styles['summary'], className)}
      data-testid={testId}
    >
      <TimeLimit className={styles['summary__time']} seconds={timeLimit} />
      {heading && <Text className={styles['summary__heading']}>{heading}</Text>}
      <h2 className={styles['summary__name']}>{name}</h2>
      <span className={styles['summary__caption']}>
        {`${questionCount} preguntas`}
      </span>
    </div>
  );
}

export { AssessmentSummary };
